// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__1YPCX","options":"AnswerScale_options__3I_-0","selected":"AnswerScale_selected__38NzF"};